import React from 'react';
import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <div className="min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto space-y-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Terms of Service</h1>
          <p className="text-xl text-white/70">Last updated: January 29, 2025</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="space-y-8"
        >
          {sections.map((section, index) => (
            <div key={index} className="glass p-8 rounded-modern space-y-4">
              <h2 className="text-2xl font-semibold text-white">{section.title}</h2>
              <div className="text-white/80 space-y-4">
                {section.content}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="glass p-8 rounded-modern mt-12"
        >
          <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
          <p className="text-white/80">
            If you have any questions about these Terms, please contact us at:{' '}
            <a
              href="mailto:legal@remuvr.com"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              legal@remuvr.com
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}

const sections = [
  {
    title: "1. Acceptance of Terms",
    content: (
      <>
        <p>
          By accessing or using Remuvr's services, you agree to be bound by these Terms of Service.
          If you disagree with any part of the terms, you may not access our service.
        </p>
      </>
    )
  },
  {
    title: "2. Service Description",
    content: (
      <>
        <p>
          Remuvr provides an AI-powered background removal service for images. We offer:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Automated background removal</li>
          <li>High-quality output images</li>
          <li>Bulk processing capabilities</li>
          <li>API access (for eligible plans)</li>
        </ul>
      </>
    )
  },
  {
    title: "3. User Obligations",
    content: (
      <>
        <p>You agree to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Provide accurate account information</li>
          <li>Maintain the security of your account</li>
          <li>Not misuse our services</li>
          <li>Comply with all applicable laws</li>
          <li>Not upload illegal or prohibited content</li>
        </ul>
      </>
    )
  },
  {
    title: "4. Intellectual Property",
    content: (
      <>
        <p>
          You retain all rights to your uploaded images. By using our service, you grant us the
          necessary rights to process your images for background removal.
        </p>
        <p className="mt-4">
          Remuvr's technology, branding, and content remain our exclusive property.
        </p>
      </>
    )
  },
  {
    title: "5. Pricing and Payments",
    content: (
      <>
        <p>
          Free tier users can process a limited number of images. Premium features require a
          subscription or credit purchase.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>All prices are in USD unless otherwise stated</li>
          <li>Subscriptions auto-renew unless cancelled</li>
          <li>Refunds are handled case-by-case</li>
        </ul>
      </>
    )
  },
  {
    title: "6. Limitation of Liability",
    content: (
      <>
        <p>
          Remuvr provides its service "as is" without any warranty. We are not liable for:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Service interruptions</li>
          <li>Data loss</li>
          <li>Processing errors</li>
          <li>Consequential damages</li>
        </ul>
      </>
    )
  }
];
